import { getPrimaryColor, getTextOnPrimaryColor } from '../../theme/defaultThemeOperators';
export const getLoadingSpinnerColor = getPrimaryColor;
export const getSecondaryLoadingSpinnerColor = getTextOnPrimaryColor;